// extracted by mini-css-extract-plugin
module.exports = {"body":"EmptyBlock_body__3d8UA"};